import MapView from '@cas/components/maps/map-view/MapView';
import MapLoader from '@cas/components/maps/map-loader/MapLoader';
import useAssetPositionsOnMap from '../hooks/useAssetPositionsOnMap';
import { RegisteredAssetDetailModel } from '@casops/store/apis/registeredAssetsApi';
import SingleAssetPositionLayer from '../single-asset-pos/SingleAssetPositionLayer';
import AssetDetailsGeofencesLayer from '../layers/asset-details-geofences-layer/AssetDetailsGeofencesLayer';
import { useGetGeofencesGeoJsonQuery } from '@casops/store/apis/geofencesApi';

interface AssetDetailsMapProps {
  data: RegisteredAssetDetailModel;
  isFetching: boolean;
}

const MAP_HEIGHT = '600px';

export const AssetDetailsMap = ({ data, isFetching }: AssetDetailsMapProps) => {
  const mapProps = useAssetPositionsOnMap(data);

  const showMap = !!data;

  const { isFetching: isGeoJsonFetching } = useGetGeofencesGeoJsonQuery(undefined, {
    refetchOnMountOrArgChange: 1800,
  });

  return (
    <MapLoader showMap={showMap} isFetching={isFetching || isGeoJsonFetching} height={MAP_HEIGHT}>
      <MapView {...mapProps} showLayersControl padding initialZoom={18}>
        <AssetDetailsGeofencesLayer checked={false} />
        {data?.posG && <SingleAssetPositionLayer posG={data.posG} />}
      </MapView>
    </MapLoader>
  );
};

export default AssetDetailsMap;
